import {
  LayoutDashboard,
  CalendarClock,
  Bot,
  Calculator,
  TrendingUp,
  Clapperboard,
} from "lucide-react";

const platforms = [
  {
    label: "Panel AI Agent HUB",
    url: "https://aiagenthub.pl",
    icon: LayoutDashboard,
  },
  {
    label: "SMS – Harmonogram",
    url: "https://sms.aiagenthub.pl",
    icon: CalendarClock,
    active: true,
  },
  {
    label: "MultiBot",
    url: "https://multibot.aiagenthub.pl",
    icon: Bot,
  },
  {
    label: "Księgowość",
    url: "https://ksiegowosc.aiagenthub.pl",
    icon: Calculator,
  },
  {
    label: "CryptoStrategy",
    url: "https://cryptostrategy.aiagenthub.pl",
    icon: TrendingUp,
  },
  {
    label: "CLIP AI",
    url: "https://clip.aiagenthub.pl",
    icon: Clapperboard,
  },
];

export function QuickAccessBar() {
  const currentHost = window.location.hostname;

  return (
    <div className="quick-access-bar">
      <div className="quick-access-inner">
        <span className="quick-access-brand">AI Agent HUB</span>
        <nav className="quick-access-nav">
          {platforms.map((p) => {
            const Icon = p.icon;
            const isActive =
              p.active || new URL(p.url).hostname === currentHost;
            return (
              <a
                key={p.url}
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`quick-access-link${isActive ? " active" : ""}`}
                title={p.label}
              >
                <Icon className="quick-access-icon" />
                <span className="quick-access-label">{p.label}</span>
              </a>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
